import React from 'react'

export default () => {
    return (
        <span className="material-symbols-outlined">monitoring</span>
    )
}